import React from 'react';
import './LoadingOverlay.css';

export default function LoadingOverlay() {
  return (
    <div className="loading-overlay">
      <div className="loader-wrapper">
        <div className="loader-container">
          <div className="loader-cube">
            <div className="loader-cube__inner" />
          </div>
          <div className="loader-cube">
            <div className="loader-cube__inner" />
          </div>
          <div className="loader-cube">
            <div className="loader-cube__inner" />
          </div>
        </div>
        <p className="loader-tagline">It's good. Make <span className="loader-tagline__accent">better</span>.</p>
      </div>
    </div>
  );
}
